export default function isBase64(property) {
  return property.substr(0, 5) === 'data:';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/fela/es/isBase64.js
// module id = 333
// module chunks = 0